import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../components/Card";
import { getMyActivity } from "../../services/stream.service";
import { useNavigate } from "react-router-dom";

function MyActivity() {
  const { t } = useTranslation();
  const [activityData, setActivityData] = useState({
    totalStreamsJoined: 0,
    totalPurchaseRequests: 0,
    leads: []
  });
  const [loading, setLoading] = useState(true);
 const navigate = useNavigate()
  useEffect(() => {
    const fetchActivity = async () => {
      try {
        setLoading(true);
        const response = await getMyActivity();
        if (response.success) {
          setActivityData(response.data);
        }
      } catch (error) {
        console.error("Error fetching activity:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchActivity();
  }, []);

  return (
    <>
      <div className="my-activity-bg py-10">
        <div className="container">
          <h1 className="headings-h1 text-zinc-950 border-b border-gray-200 pb-[15px] mb-[30px]">
            {t('advertiser.activity.heading')}
          </h1>

          <div className="overview-bg mb-4">
            <h2 className="headings-h2 text-zinc-950 mb-[20px]">{t('advertiser.activity.overview')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
              <div className="flex items-center justify-between gap-[10px] flex-wrap rounded-[10px] bg-orange-300 p-[20px] md:p-[25px]">
                <div className="flex-1 flex flex-col gap-[5px]">
                  <p className="text-white text-[16px] md:text-[20px]">
                    {t('advertiser.activity.total_purchase_requests')}
                  </p>
                  <span className="text-white bold text-[24px] md:text-[32px] lg:text-[46px] leading-normal">
                    {activityData.totalPurchaseRequests}
                  </span>
                </div>
                <img src="/images/overview-icon1.png" alt="overview-icon1" />
              </div>

              <div className="flex items-center justify-between gap-[10px] flex-wrap rounded-[10px] bg-blue-400 p-[20px] md:p-[25px]">
                <div className="flex-1 flex flex-col gap-[5px]">
                  <p className="text-white text-[16px] md:text-[20px]">
                    {t('advertiser.activity.streams_joined')}
                  </p>
                  <span className="text-white bold text-[24px] md:text-[32px] lg:text-[46px] leading-normal">
                    {activityData.totalStreamsJoined}
                  </span>
                </div>
                <img src="/images/overview-icon2.png" alt="overview-icon1" />
              </div>
            </div>
          </div>

          <div className="product-bg">
            <h2 className="headings-h2 text-zinc-950 mb-[20px]">{t('header.products')}</h2>
            {loading ? (
              <div className="text-center py-10">{t('advertiser.leads.loading')}</div>
            ) : activityData.leads.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[20px]">
                {activityData.leads.map((item, index) => (
                  <div key={index} className="w-full" onClick={() => navigate(`/user/product-details?o_id=${item?.product_id?._id}`)}>
                    <Card
                      images={item.product_id?.image || "/images/pr1.png"}
                      title={item.product_id?.title}
                      subtitle={item.stream_id?.title}
                      price={item.product_id?.price}
                      isAskForPrice={item.product_id?.isAskForPrice}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-10 text-zinc-500">{t('advertiser.activity.no_activity')}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MyActivity;
